/**
 * NextAuth `redirect` callback body — extracted so it can be unit-tested without booting
 * the full NextAuth handler (which pulls in Node crypto, Edge runtime guards, etc.).
 *
 * Uses strict origin equality rather than string `startsWith(baseUrl)`, which would accept
 * cross-origin URLs like `https://www.bestjobs.eu.evil.com/` (subdomain confusion). When
 * the candidate URL cannot be resolved against `baseUrl`, fail closed to `baseUrl`.
 */
export const redirectCallback = (url: string, baseUrl: string): string => {
  try {
    const targetUrl = new URL(url, baseUrl);
    const baseOrigin = new URL(baseUrl).origin;
    if (targetUrl.origin === baseOrigin) {
      return targetUrl.toString();
    }
  } catch {
    // Malformed URL — fall through to baseUrl.
  }
  return baseUrl;
};
